import React, { useEffect } from 'react';
// import styles from './Select.scss';
import MuiSelect from '../MaterialUi/Select';

import { IPropertyWizardInput } from './NewPropertyWizard';
import styles from './NewPropertyWizard.scss';

export interface ISelectProps extends IPropertyWizardInput { }

const Select: React.FC<React.PropsWithChildren<ISelectProps>> = ({ step: input = null, data = null, onChange = () => { } }) => {
    const value = data[input.name] || Object.keys(input.options).find((i) => true) || '';
    useEffect(() => {
        // set default value in parent component
        if (typeof data[input.name] === 'undefined') {
            const val = Object.keys(input.options).find((i) => true);
            onChange(input.name, val);
        }
    }, []);

    const handleChange = (ev) => {
        onChange(input.name, ev.target.value);
    };

    return (
        <MuiSelect key={input.name} label={input.title || 'Bitte auswählen:'} name={input.name} value={value} onChange={handleChange} fullWidth>
            {Object.keys(input.options).map((key) => {
                const o = input.options[key];

                return (
                    <option key={key} value={key}>
                        {o}
                    </option>
                );
            })}
        </MuiSelect>
    );
};

export default Select;
